import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  onError?: () => void
}

interface State {
  hasError: boolean
  message: string
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' }

  static getDerivedStateFromError(error: unknown): State {
    return {
      hasError: true,
      message: error instanceof Error ? error.message : String(error),
    }
  }

  componentDidCatch(): void {
    this.props.onError?.()
  }

  handleReset = (): void => {
    this.setState({ hasError: false, message: '' })
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
          <h2 className="text-lg font-semibold text-red-600">
            Diese Ansicht konnte nicht geladen werden
          </h2>
          <p className="max-w-md text-sm text-[var(--muted-foreground)]">
            Ein unerwarteter Fehler ist aufgetreten. Die übrige Anwendung bleibt nutzbar.
          </p>
          <p className="max-w-md rounded bg-red-50 px-3 py-2 font-mono text-xs text-red-700">
            {this.state.message}
          </p>
          <button
            onClick={this.handleReset}
            className="rounded-md bg-[var(--primary)] px-3 py-1.5 text-sm text-[var(--primary-foreground)] hover:opacity-90"
          >
            Erneut versuchen
          </button>
        </div>
      )
    }
    return this.props.children
  }
}
